import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";
import { fetchRootContainer, fetchMemberships } from "./strapi/queries";
import MainLayout from "./MainLayout";
import { ProductProvider } from './ProductContext';
import MergedGearCheckPage from "./pages/MergedGearCheckPage";
import CheckReportPage from "./pages/CheckReportPage";
import ContactPage from "./pages/ContactPage";
import IndexPage from "./pages/IndexPage";
import GroupManagementPage from "./pages/GroupManagementPage"; // Import the new component
import "./App.css";

import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [memberships, setMemberships] = useState([]); // Moved from MainLayout
  const [activeGroup, setActiveGroup] = useState(null); // statt ""
  const [rootContainer, setRootContainer] = useState(null); // statt ""
  const [groupChangeKey, setGroupChangeKey] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    if (token) {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      setUser(storedUser);
    }
  }, []);

  // Effect to load memberships
  useEffect(() => {
    const loadMemberships = async () => {
      try {
        const data = await fetchMemberships();
        if (data && data.data) {
          setMemberships(data.data);

          // Suche nach einer Gruppe, deren Name "Privat" enthält
          const privatGroup = data.data.memberships.find(
            (m) => m.group && m.group.name && m.group.name.includes(" Privat")
          );

          // Setze die gefundene "Privat"-Gruppe oder alternativ die erste Gruppe
          if (privatGroup) {
            setActiveGroup(privatGroup.group);
          } else if (data.data.memberships.length > 0) {
            setActiveGroup(data.data.memberships[0].group);
          }
        }
      } catch (error) {
        console.error("Error fetching memberships:", error);
      }
    };
    const token = localStorage.getItem("jwt");
    if(token) {
      loadMemberships();
    }
  }, [user]); // Depend on setUser to ensure it's stable

  useEffect(() => {
    const loadGroupItems = async () => {
      const token = localStorage.getItem("jwt");
      if (activeGroup?.documentId && token) {
        try {
          const data = await fetchRootContainer(activeGroup.documentId);
          const path = location.pathname.toLowerCase();  // aktuelle URL
          if (data && data.containers && data.containers.documentId) {
            setRootContainer(data.containers.documentId);
            if (path.includes("/gear")) {
              navigate(`/gear/${data.containers.documentId}`);
            } else if (path.includes("/check")) {
              navigate(`/checkreport/${activeGroup.documentId}`);
            } else if (path.includes("/group")) {
              // do nothing
            } else {
              navigate(`/`);
            }
          } else {
            console.error("Kein Container gefunden");
          }
        } catch (error) {
          console.error("Fehler beim Laden des Root-Containers.");
        }
      }
    };
    loadGroupItems();
  }, [activeGroup]); // Added navigate and location.pathname to dependencies

  const handleLoginSuccess = (user) => {
    setUser(user);
    localStorage.setItem("user", JSON.stringify(user));
  };

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginForm onLoginSuccess={handleLoginSuccess} />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }

  return (
    <ProductProvider>
      <MainLayout
        setUser={setUser}
        user={user}
        activeGroup={activeGroup}
        setActiveGroup={(group) => {
          setActiveGroup(group);
          setGroupChangeKey(prevKey => prevKey + 1);
        }}
        rootContainer={rootContainer}
        groupChangeKey={groupChangeKey}
        memberships={memberships} // Pass memberships to MainLayout
        setMemberships={setMemberships} // Pass setMemberships to MainLayout
      >
        <Routes>
          <Route path="/" element={<IndexPage />} />
          <Route path="/gear/:containerId" element={<MergedGearCheckPage groupChangeKey={groupChangeKey} />} />
          <Route path="/gear/:containerId/:itemDocumentId" element={<MergedGearCheckPage groupChangeKey={groupChangeKey} />} />
          <Route path="/checkreport/:activeGroupId" element={<CheckReportPage memberships={memberships} groupChangeKey={groupChangeKey} />} />
          <Route path="/checkreport/:activeGroupId/:itemDocumentId" element={<MergedGearCheckPage groupChangeKey={groupChangeKey} />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/group-management" element={<GroupManagementPage memberships={memberships} />} /> 
          {/* Add a catch-all for any other routes when authenticated */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </MainLayout>
    </ProductProvider>
  );
}


export default AppWrapper;
